import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import laptopImg from "../../Assets/Projects/about.jpg";

function AboutContent() {
  const handleDownloadResume = () => {
    const link = document.createElement('a');
    link.href = '/Resume_Yaoyi Wang.pdf';
    link.download = 'Resume_Yaoyi Wang.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container fluid className="about-section">
      <Container>
        <div className="about-header">
          <h1>It's me here</h1>
          <div className="about-divider">
            <span></span>
          </div>
        </div>

        <Row className="about-wrapper">
          <Col md={6} className="about-img">
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>

          <Col md={6} className="about-content">
            <h2 className="about-name">
              Hi, I am <span className="highlight">Yaoyi Wang</span> (She/Her),
              born and raised in China, currently living in Vancouver, BC, Canada.
            </h2>

            <p className="about-description">
              Finishing my MSCS at Northeastern University Vancouver, after a detour
              through English Literature, Finance, and Anthropology.
            </p>

            <div className="about-highlights">
              <h3>Currently focused on:</h3>
              <ul>
                <li>Cloud infrastructure and platform engineering</li>
                <li>Kubernetes, CI/CD, and deployment automation</li>
                <li>System reliability, observability, and security</li>
                <li>Backend systems with Python, TypeScript, Go, and SQL</li>
                <li>The blurry line between platform and AI engineering</li>
              </ul>
            </div>

            <p className="about-goal">
              I aim to make people's lives more convenient by developing secure and meaningful applications.
              Eager to contribute my computer science skills within a professional setting!
            </p>

            <button className="resume-button" onClick={handleDownloadResume}>
              Get Resume
            </button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default AboutContent;
